import { TxInfo } from "@terra-money/terra.js";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";

export const writeDebug = (msg: string, data: {}) => console.debug("---DEBUG---", msg, data)

export type StatCategory = "bad" | "normal" | "good" | "unknown";

export const determineStat = (value: number, maxValue: number): StatCategory => {
    const stats: StatCategory[] = ['bad', 'normal', 'good'];
    for (let i = 0; i < 3; i++) {
        let min = maxValue * i / 3;
        let max = maxValue * (i + 1) / 3;

        if (min <= value && value <= max) {
            return stats[i]
        }
    }

    return "unknown";
}

export const getEvent = (tx: TxInfo, key: string) => {
    const eventsByType = tx.logs?.[0]?.eventsByType;
    if (!eventsByType) return;

    return Object.entries(eventsByType).find(([index]) => index === key)?.[1];
}

export const errorAlert = (message: string, reason: any) => {
    const MySwal = withReactContent(Swal)
    return MySwal.fire({
        title: message,
        text: reason,
        background: '#282c34',
        icon: 'error',
        color: '#fff',
        confirmButtonColor: "#2563eb"
    })
}

export const successAlert = (message: string) => {
    const MySwal = withReactContent(Swal)
    return MySwal.fire({
        title: "success",
        text: message,
        background: '#282c34',
        icon: 'success',
        color: '#fff',
        confirmButtonColor: "#2563eb"
    })
}

export const warningAlert = (message: string) => {
    const MySwal = withReactContent(Swal)
    return MySwal.fire({
        title: "failed",
        text: message,
        background: '#282c34',
        icon: 'warning',
        color: '#fff',
        confirmButtonColor: "#2563eb"
    })
}

export const showLoading = ({ description = "" }) => {
    const MySwal = withReactContent(Swal)
    return MySwal.fire({
        title: "<div class=\"lds-ellipsis\"><div></div><div></div><div></div><div></div></div>",
        text: `${description}...`,
        background: '#282c34',
        color: '#fff',
        allowOutsideClick: false,
        showConfirmButton: false,
        allowEscapeKey: false,
    })
}

export const closeLoading = () => {
    const MySwal = withReactContent(Swal)
    return MySwal.close();
}

export const openModal = (name: string) => {
    const button = document.createElement("button");
    button.style.display = "none";
    document.body.appendChild(button);

    button.setAttribute("data-bs-toggle", 'modal');
    button.setAttribute("data-bs-target", `#${name}`);

    button.click();
    button.remove();
}

export const closeModal = (name: string) => {
    const modal = document.getElementById(name);
    const button = document.createElement("button");
    button.style.display = "none";
    modal?.appendChild(button);

    button.setAttribute("data-bs-dismiss", 'modal');

    button.click();
    button.remove();
}